import React from 'react'
import Loader from './Loader'

const FullScreenLoader = ({ loadingMessage }) => {
  return (
    <div className="fullpageLoader">
      <div>
        <Loader />
        <span>{loadingMessage}</span>
      </div>
    </div>
  )
}

export default FullScreenLoader
